import { Component, OnInit, OnDestroy } from '@angular/core';
import { ComponentsService } from 'src/app/components.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-betstop-status',
    templateUrl: './betstop-status.component.html',
    styleUrls: ['./betstop-status.component.scss']
})
export class BetstopStatusComponent implements OnInit, OnDestroy {
    perms: any;
    reason: string = '';
    addUserClicked: boolean = false;
    isBlockClicked: boolean = false;
    isUnblockClicked: boolean = false;
    dataSourcebetstopStatusTable: MatTableDataSource<betstopStatusTable>;
    columnsBetstop: string[] = [
        'status',
        'clientName',
        'reasonForBlocking',
        'blockDateTime',
        'blockedBy',
        'unblockDateTime',
        'unblockedBy',
        'action'
    ];
    editMode: boolean = false;
    displayMessage: boolean = false;
    message: string;
    hideBtn: boolean = false;
    clientName: string;
    private clientChangeSubscription: Subscription;

    constructor(
        private service: ComponentsService,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.perms = this.service.getUsersPerm();

        this.service.getClientName(this.perms.clientUuid).subscribe((data) => {
            this.clientName = data.data;
        });

        this.getBetstopStatus(this.service.getUsersPerm().superAdmin == 1);
    }

    ngOnDestroy(): void {
        if (this.clientChangeSubscription) {
            this.clientChangeSubscription.unsubscribe();
        }
    }

    async getBetstopStatus(isSuperAdmin: boolean) {
        let data;

        if (isSuperAdmin) {
            data = await this.service.getBetstopStatus(); // all clients
        } else {
            data = await this.service.getBetstopStatusForClient(
                this.perms.clientUuid
            ); // specific client
        }

        // Assuming 'data' is your API response
        const betstopData = Array.isArray(data.betstopStatus)
            ? data.betstopStatus // already an array
            : [data.betstopStatus]; // wrap single object

        const mapped = betstopData.map((b: any, index: number) => ({
            id: index + 1, // optional
            clientName: b.client?.name ?? '-',
            clientUuid: b.clientUuid,
            status: b.status,
            reasonForBlocking: b.reason,
            blockDateTime: b.blockDateTime,
            unblockDateTime: b.unblockDateTime,
            blockedBy: b.blockedByUser
                ? `${b.blockedByUser.name} ${b.blockedByUser.last_name}`
                : '-',
            unblockedBy: b.unblockedByUser
                ? `${b.unblockedByUser.name} ${b.unblockedByUser.last_name}`
                : '-',
            isReasonExpanded: false
        }));

        this.dataSourcebetstopStatusTable =
            new MatTableDataSource<betstopStatusTable>(mapped);
    }

    fadeOutMessage() {
        if (this.displayMessage) {
            setTimeout(() => {
                this.displayMessage = false;
                this.message = '';
            }, 5000);
        }
    }

    refresh() {
        this.getBetstopStatus(this.service.getUsersPerm().superAdmin == 1);
        if (this.dataSourcebetstopStatusTable) {
            this.dataSourcebetstopStatusTable.filter = '';
        }
    }

    start(clientUuid: string) {
        if (this.reason === '') {
            this.message = 'You must enter reason.';
            this.displayMessage = true;
            this.fadeOutMessage();
            return;
        }
        this.service
            .stopbet(
                clientUuid,
                this.reason,
                this.service.getUsersPerm().superAdmin == 1,
                false
            )
            .then((res) => {
                if (res.success) {
                    this.refresh();
                } else {
                    this.message =
                        'You are not allowed to start at this moment. Stopped by super admin';
                    this.displayMessage = true;
                    this.fadeOutMessage();
                }
            });
    }

    stop(clientUuid: string) {
        if (this.reason === '') {
            this.message = 'You must enter reason.';
            this.displayMessage = true;
            this.fadeOutMessage();
            return;
        }
        this.service
            .stopbet(
                clientUuid,
                this.reason,
                this.service.getUsersPerm().superAdmin == 1,
                true
            )
            .then(() => {
                this.refresh();
            });
    }
}

export interface betstopStatusTable {
    id: number;
    clientName: string;
    clientUuid: string;
    status: number;
    reasonForBlocking: string;
    blockDateTime: string;
    unblockDateTime: string;
    blockedBy: string;
    unblockedBy: string;
    isReasonExpanded?: boolean; // Add these properties to track expanded state
}
